export function deleteDragButton() {
  const existing_drag_btn = document.getElementById(`draggable_svg`)
  if (existing_drag_btn) existing_drag_btn.remove()
}

export function createDragButton(element_key) {
  deleteDragButton()

  const parent_g = document.getElementById(element_key)
  const parent_svg = parent_g.closest('svg')

  const text_obj = parent_g.querySelector('text')
  const text_box = text_obj.getBBox()

  const currentX = text_box.x + text_box.width - 4
  const currentY = text_box.y - 14

  const draggable_svg = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'svg'
  )
  draggable_svg.setAttribute('id', 'draggable_svg')
  draggable_svg.setAttribute('x', currentX)
  draggable_svg.setAttribute('y', currentY)
  draggable_svg.setAttribute('width', 20)
  draggable_svg.setAttribute('height', 20)

  const g = document.createElementNS('http://www.w3.org/2000/svg', 'g')

  const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect')
  rect.setAttribute('fill', '#fff0')
  rect.setAttribute('stroke', '#000')
  rect.setAttribute('width', 20)
  rect.setAttribute('height', 20)
  g.appendChild(rect)

  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
  path.setAttribute(
    'd',
    'm16.37846,9.19027l0,-2.11581c-0.00116,-0.06195 0.02258,-0.12186 0.06559,-0.16603c0.04315,-0.04417 0.10207,-0.06909 0.16361,-0.06909c0.06168,0.00087 0.12061,0.0258 0.16434,0.06968l3.07028,3.091l-3.06594,3.08664c-0.06704,0.0637 -0.16506,0.08163 -0.25006,0.04578c-0.08499,-0.03571 -0.14117,-0.11836 -0.14348,-0.21107l0,-2.33359l-3.89196,0c-0.20546,0 -0.39528,-0.11034 -0.4981,-0.2895c-0.10266,-0.17915 -0.10266,-0.39985 0,-0.579c0.1028,-0.17915 0.29262,-0.28964 0.4981,-0.28964l3.64555,0c0.06415,0.00248 0.1264,-0.02187 0.1723,-0.0672c0.04576,-0.04519 0.07109,-0.10757 0.06978,-0.17215l-0.00001,-0.00001zm-5.80756,-5.61166l0,3.91823c0,0.20684 -0.10961,0.39794 -0.28755,0.50146c-0.17795,0.10334 -0.39717,0.10334 -0.57512,0c-0.17795,-0.10349 -0.28755,-0.2946 -0.28755,-0.50146l0,-3.91823l-2.32228,0c-0.06183,0.00117 -0.12148,-0.02332 -0.16491,-0.06778c-0.04344,-0.04446 -0.0666,-0.1051 -0.06415,-0.16734c-0.00116,-0.06035 0.0223,-0.11851 0.06486,-0.16108l3.06594,-3.09115l3.07028,3.091l0,0.00015c0.06762,0.06604 0.08803,0.1669 0.05183,0.25436c-0.03634,0.08746 -0.12206,0.14372 -0.21617,0.14183l-2.33518,0l-0.00002,0.00001zm-1.14587,8.94215c0,-0.20684 0.10961,-0.3981 0.28755,-0.50146c0.17795,-0.10349 0.39717,-0.10349 0.57512,0c0.17795,0.10334 0.28755,0.2946 0.28755,0.50146l0,3.91823l2.31795,0c0.06183,-0.00131 0.12162,0.02318 0.16491,0.06778c0.04344,0.04446 0.0666,0.10495 0.06429,0.16734c0.00101,0.06035 -0.02244,0.11836 -0.06486,0.16108l-3.05738,3.07365l-3.07028,-3.091l0,-0.00015c-0.04315,-0.0433 -0.06733,-0.10204 -0.06733,-0.16326s0.02418,-0.11997 0.06733,-0.16326c0.04416,-0.04563 0.10526,-0.07084 0.16854,-0.06968l2.33518,0l-0.00856,-3.90074zm-6.19675,0.57023l-3.07043,-3.091l3.06594,-3.08664l0.00014,0c0.06704,-0.0637 0.16506,-0.08163 0.25006,-0.04578c0.08499,0.03571 0.14117,0.11836 0.14348,0.21107l0,2.33359l3.89196,0c0.20546,0 0.39528,0.11034 0.4981,0.2895c0.10266,0.17915 0.10266,0.39985 0,0.579c-0.1028,0.17915 -0.29262,0.28964 -0.4981,0.28964l-3.89196,0l0,2.35094c0,0.12813 -0.10193,0.23264 -0.2292,0.23498c-0.06168,-0.00087 -0.12061,-0.0258 -0.16434,-0.06968l0.00434,0.00438z'
  )
  g.appendChild(path)
  draggable_svg.appendChild(g)

  parent_svg.appendChild(draggable_svg)

  // let xOffset = 0
  // let yOffset = 0

  // function startDrag(event) {
  //   event.preventDefault()

  //   const getClientXY = e => {
  //     let clientX
  //     let clientY
  //     if (e.touches) {
  //       clientX = e.touches[0].clientX
  //       clientY = e.touches[0].clientY
  //     } else {
  //       clientX = e.clientX
  //       clientY = e.clientY
  //     }

  //     return { clientX, clientY }
  //   }

  //   let point = parent_svg.createSVGPoint()
  //   const { clientX, clientY } = getClientXY(event)
  //   point.x = clientX
  //   point.y = clientY
  //   point = point.matrixTransform(parent_svg.getScreenCTM().inverse())

  //   xOffset = point.x - currentX
  //   yOffset = point.y - currentY

  //   const moveHandler = e => {
  //     e.preventDefault()
  //     const { clientX: cx, clientY: cy } = getClientXY(e)

  //     point.x = cx
  //     point.y = cy
  //     const cursor = point.matrixTransform(parent_svg.getScreenCTM().inverse())

  //     currentX = cursor.x - xOffset
  //     currentY = cursor.y - yOffset

  //     draggable_svg.setAttribute('x', currentX)
  //     draggable_svg.setAttribute('y', currentY)
  //   }

  //   const endHandler = () => {
  //     document.removeEventListener('mousemove', moveHandler)
  //     document.removeEventListener('mouseup', endHandler)
  //     document.removeEventListener('touchmove', moveHandler)
  //     document.removeEventListener('touchend', endHandler)
  //   }

  //   document.addEventListener('mousemove', moveHandler)
  //   document.addEventListener('mouseup', endHandler)
  //   document.addEventListener('touchmove', moveHandler)
  //   document.addEventListener('touchend', endHandler)
  // }

  // draggable_svg.addEventListener('mousedown', startDrag)
  // draggable_svg.addEventListener('touchstart', startDrag)
}
